var map = {
	"app/administracao/administracao.module.ngfactory": [
		"./src/$$_gendir/app/administracao/administracao.module.ngfactory.ts",
		"common",
		"administracao.module"
	],
	"app/autenticacao/autenticacao.module.ngfactory": [
		"./src/$$_gendir/app/autenticacao/autenticacao.module.ngfactory.ts",
		"common",
		"autenticacao.module"
	],
	"app/conteudo/conteudo.module.ngfactory": [
		"./src/$$_gendir/app/conteudo/conteudo.module.ngfactory.ts",
		"common",
		"conteudo.module"
	],
	"app/documentacao/documentacao.module.ngfactory": [
		"./src/$$_gendir/app/documentacao/documentacao.module.ngfactory.ts",
		"common",
		"documentacao.module"
	],
	"app/editorial/editorial.module.ngfactory": [
		"./src/$$_gendir/app/editorial/editorial.module.ngfactory.ts",
		"common",
		"editorial.module"
	],
	"app/enquete/enquete.module.ngfactory": [
		"./src/$$_gendir/app/enquete/enquete.module.ngfactory.ts",
		"common",
		"enquete.module"
	],
	"app/estatistica/estatistica.module.ngfactory": [
		"./src/$$_gendir/app/estatistica/estatistica.module.ngfactory.ts",
		"common",
		"estatistica.module"
	],
	"app/evento-goi/evento-goi.module.ngfactory": [
		"./src/$$_gendir/app/evento-goi/evento-goi.module.ngfactory.ts",
		"common",
		"evento-goi.module"
	],
	"app/evento/evento.module.ngfactory": [
		"./src/$$_gendir/app/evento/evento.module.ngfactory.ts",
		"common",
		"evento.module"
	],
	"app/excluir-conta/autenticacao.module.ngfactory": [
		"./src/$$_gendir/app/excluir-conta/autenticacao.module.ngfactory.ts",
		"common",
		"autenticacao.module.0"
	],
	"app/inicio/inicio.module.ngfactory": [
		"./src/$$_gendir/app/inicio/inicio.module.ngfactory.ts",
		"common",
		"inicio.module"
	],
	"app/midia/browser/midia-browser.module.ngfactory": [
		"./src/$$_gendir/app/midia/browser/midia-browser.module.ngfactory.ts",
		"common",
		"midia-browser.module"
	],
	"app/midia/midia.module.ngfactory": [
		"./src/$$_gendir/app/midia/midia.module.ngfactory.ts",
		"common",
		"midia.module"
	],
	"app/notificacao/notificacao.module.ngfactory": [
		"./src/$$_gendir/app/notificacao/notificacao.module.ngfactory.ts",
		"common",
		"notificacao.module"
	],
	"app/quiz/quiz.module.ngfactory": [
		"./src/$$_gendir/app/quiz/quiz.module.ngfactory.ts",
		"common",
		"quiz.module"
	],
	"app/rest/rest-conteudo/rest-conteudo.module.ngfactory": [
		"./src/$$_gendir/app/rest/rest-conteudo/rest-conteudo.module.ngfactory.ts",
		"common",
		"rest-conteudo.module"
	],
	"app/rest/rest-secao/rest-secao.module.ngfactory": [
		"./src/$$_gendir/app/rest/rest-secao/rest-secao.module.ngfactory.ts",
		"common",
		"rest-secao.module"
	],
	"app/rest/rest.module.ngfactory": [
		"./src/$$_gendir/app/rest/rest.module.ngfactory.ts",
		"common",
		"rest.module"
	],
	"app/secao/secao.module.ngfactory": [
		"./src/$$_gendir/app/secao/secao.module.ngfactory.ts",
		"common",
		"secao.module"
	],
	"app/slides/slides.module.ngfactory": [
		"./src/$$_gendir/app/slides/slides.module.ngfactory.ts",
		"common",
		"slides.module"
	],
	"app/sorteio/sorteio.module.ngfactory": [
		"./src/$$_gendir/app/sorteio/sorteio.module.ngfactory.ts",
		"common",
		"sorteio.module"
	],
	"app/web/web-conteudo/web-conteudo.module.ngfactory": [
		"./src/$$_gendir/app/web/web-conteudo/web-conteudo.module.ngfactory.ts",
		"common",
		"web-conteudo.module"
	],
	"app/web/web-secao/web-secao.module.ngfactory": [
		"./src/$$_gendir/app/web/web-secao/web-secao.module.ngfactory.ts",
		"common",
		"web-secao.module"
	],
	"app/web/web.module.ngfactory": [
		"./src/$$_gendir/app/web/web.module.ngfactory.ts",
		"common",
		"web.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main